import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { loggedInState, userInfoState } from '../../recoil/atoms'
import { TOUR_STEPS, activeRoleOf } from '../../assets/helpContent'
import GuidedTour from './GuidedTour'

/**
 * راه‌انداز تور آموزشی — مقاوم در برابر remount:
 * - وضعیت فعال بودن تور + شمارهٔ گام در sessionStorage نگهداری میشود
 *   تا اگر اپ وسط تور remount شد، تور از همان گام ادامه یابد.
 * - پایان/رد شدن → فلگ tour_done_<role> در localStorage (دیگر خودکار باز نمیشود)
 */
const TourLauncher = () => {
  const loggedIn = useRecoilValue(loggedInState)
  const userInfo = useRecoilValue(userInfoState)
  // نقشِ فعال (اگر کاربر دو نقش دارد) — وگرنه نقشِ اصلیِ حساب
  const role = userInfo ? activeRoleOf(userInfo) : null
  const [open, setOpen] = useState(false)
  const [initialStep, setInitialStep] = useState(0)
  const [booted, setBooted] = useState(false)

  useEffect(() => {
    if (!loggedIn || !role) return
    const key = 'tour_done_' + role
    const active = sessionStorage.getItem('tour_active') === '1'
    if (localStorage.getItem(key) && !active) {
      // قبلاً تور این نقش دیده شده
      setBooted(true)
      return
    }
    const step = active ? parseInt(sessionStorage.getItem('tour_step') || '0', 10) || 0 : 0
    setInitialStep(step)
    setOpen(true)
    sessionStorage.setItem('tour_active', '1')
    setBooted(true)
  }, [loggedIn, role])

  const finish = () => {
    setOpen(false)
    sessionStorage.removeItem('tour_active')
    sessionStorage.removeItem('tour_step')
    if (role) localStorage.setItem('tour_done_' + role, '1')
  }

  const onStepChange = (idx) => {
    sessionStorage.setItem('tour_step', String(idx))
  }

  if (!booted) return null
  if (!open) return null
  if (!role) return null

  return (
    <GuidedTour
      steps={TOUR_STEPS[role] || TOUR_STEPS.Contractor}
      initialStep={initialStep}
      onStepChange={onStepChange}
      onDone={finish}
    />
  )
}

export default TourLauncher
